/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupssystemcreated2Inputs */

const en_groupssystemcreated2 = /** @type {(inputs: Groupssystemcreated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group created`)
};

const de_groupssystemcreated2 = /** @type {(inputs: Groupssystemcreated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe erstellt`)
};

/**
* | output |
* | --- |
* | "Group created" |
*
* @param {Groupssystemcreated2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupssystemcreated2 = /** @type {((inputs?: Groupssystemcreated2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupssystemcreated2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupssystemcreated2(inputs)
	return de_groupssystemcreated2(inputs)
});
export { groupssystemcreated2 as "groupsSystemCreated" }